/**
 * Déclenche le sticky header.
 */
export const stickyHeader = () => {
    // Seuil de déclenchement du sticky header
    const stickyThreshold = 300;

    document.addEventListener("scroll", () => {
        if (window.scrollY >= stickyThreshold) {
            document.querySelector(".headerSite").classList.add("sticky");
        } else {
            document.querySelector(".headerSite").classList.remove("sticky");
        }
    });
};
